import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  de: {
    translation: {
      status_ok: "Alles in Ordnung",
      status_ok_desc: "Keine bekannten Störungen an dieser Site.",
      status_disruption: "Störung bekannt",
      status_disruption_desc: "Aktuell ist eine Störung bekannt – wir arbeiten daran.",
      disruption_report_anyway: "Trotzdem melden",
      status_help_title: "WLAN-Probleme?",
      status_help_desc: "Hier helfen wir dir Schritt für Schritt – oder du kannst direkt ein Ticket einreichen.",
      since: "Seit",
      error_title: "Seite nicht gefunden",
      error_desc: "Dieser Link ist ungültig oder abgelaufen.",
      loading: "Wird geladen…",
      severity_critical: "Kritisch",
      severity_warning: "Warnung",
      check_wan_down: "Internetverbindung unterbrochen",
      check_ap_offline: "WLAN-Zugangspunkt nicht erreichbar",
      check_controller_offline: "Controller nicht erreichbar",
      check_dhcp_pool_exhaustion: "Netzwerk überlastet",
      check_disconnect_spike: "Erhöhte Verbindungsabbrüche",
      check_unknown: "Unbekannte Störung",
      // Self-help general
      selfhelp_title: "Selbsthilfe",
      selfhelp_intro: "Bitte folge diesen Schritten, um das Problem zu beheben.",
      os_select_label: "Betriebssystem wählen",
      os_ios: "iPhone / iPad",
      os_android: "Android",
      os_windows: "Windows",
      os_macos: "macOS",
      os_chromeos: "ChromeOS",
      os_linux: "Linux",
      step_x_of_y: "Schritt {{current}} von {{total}}",
      step_next: "Weiter",
      step_prev: "Zurück",
      step_problem_solved: "Problem gelöst ✓",
      step_still_problem: "Problem besteht noch",
      report_problem: "Problem melden",
      disruption_help_anyway: "Trotzdem Hilfe benötigen?",
      start_help: "WLAN-Hilfe starten",
      selfhelp_solved_title: "Gut gemacht!",
      selfhelp_solved_desc: "Schön, dass das Problem behoben ist.",
      back_to_status: "Zurück zur Statusseite",
      os_detected: "Erkanntes OS",
      os_change: "Anderes OS",
      // iOS steps
      step_ios_1_title: "WLAN aus- und wieder einschalten",
      step_ios_1_desc:
        "Öffne die Einstellungen-App und tippe auf 'WLAN'. Schalte WLAN aus, warte 5 Sekunden und schalte es wieder ein.",
      step_ios_2_title: "Netzwerk vergessen und neu verbinden",
      step_ios_2_desc:
        "Tippe in den WLAN-Einstellungen auf das (i)-Symbol neben dem Netzwerknamen. Wähle 'Dieses Netzwerk ignorieren' und verbinde dich dann neu.",
      step_ios_3_title: "Flugmodus kurz aktivieren",
      step_ios_3_desc:
        "Wische vom oberen Bildschirmrand nach unten, um das Kontrollzentrum zu öffnen. Tippe auf das Flugzeug-Symbol, warte 10 Sekunden und tippe erneut darauf.",
      step_ios_4_title: "iPhone neu starten",
      step_ios_4_desc:
        "Halte die Seitentaste und eine Lautstärketaste gleichzeitig gedrückt, bis der Ausschalter erscheint. Schiebe ihn nach rechts und starte das Gerät nach 30 Sekunden wieder.",
      // Android steps
      step_android_1_title: "WLAN aus- und wieder einschalten",
      step_android_1_desc:
        "Wische vom oberen Bildschirmrand nach unten, um die Schnelleinstellungen zu öffnen. Tippe auf das WLAN-Symbol, warte 5 Sekunden und tippe erneut darauf.",
      step_android_2_title: "Netzwerk vergessen und neu verbinden",
      step_android_2_desc:
        "Öffne die Einstellungen und tippe auf 'WLAN'. Tippe lange auf den Netzwerknamen und wähle 'Vergessen'. Verbinde dich anschließend erneut.",
      step_android_3_title: "Gerät neu starten",
      step_android_3_desc:
        "Halte den Ein-/Ausschalter gedrückt und wähle 'Neu starten'. Nach dem Neustart wieder mit dem WLAN verbinden.",
      step_android_4_title: "Flugmodus kurz aktivieren",
      step_android_4_desc:
        "Wische vom oberen Bildschirmrand nach unten und tippe auf das Flugzeug-Symbol. Warte 10 Sekunden und schalte den Flugmodus wieder aus.",
      // Windows steps
      step_windows_1_title: "WLAN aus- und wieder einschalten",
      step_windows_1_desc:
        "Klicke unten rechts in der Taskleiste auf das WLAN-Symbol und dann auf 'WLAN ausschalten'. Warte 10 Sekunden und schalte es wieder ein.",
      step_windows_2_title: "Netzwerk trennen und erneut verbinden",
      step_windows_2_desc:
        "Klicke auf das WLAN-Symbol in der Taskleiste, dann auf das Netzwerk und anschließend auf 'Trennen'. Danach erneut auf das Netzwerk klicken und verbinden.",
      step_windows_3_title: "Computer neu starten",
      step_windows_3_desc:
        "Klicke auf das Windows-Symbol, dann auf das Ein/Aus-Symbol und wähle 'Neu starten'. Nach dem Neustart erneut mit dem WLAN verbinden.",
      step_windows_4_title: "Prüfen ob andere Geräte betroffen sind",
      step_windows_4_desc:
        "Versuche mit einem anderen Gerät (z.B. Smartphone) eine Verbindung herzustellen. Wenn das andere Gerät auch kein Internet hat, liegt das Problem am Netzwerk – bitte melde es uns.",
      // macOS steps
      step_macos_1_title: "WLAN aus- und wieder einschalten",
      step_macos_1_desc:
        "Klicke oben rechts in der Menüleiste auf das WLAN-Symbol und wähle 'WLAN deaktivieren'. Warte 5 Sekunden und aktiviere es wieder.",
      step_macos_2_title: "Netzwerk vergessen und neu verbinden",
      step_macos_2_desc:
        "Öffne die Systemeinstellungen und klicke auf 'WLAN'. Klicke neben dem Netzwerknamen auf 'Details' und dann auf 'Dieses Netzwerk ignorieren'. Danach erneut verbinden.",
      step_macos_3_title: "Mac neu starten",
      step_macos_3_desc:
        "Klicke oben links auf das Apple-Symbol und wähle 'Neustart…'. Nach dem Neustart erneut mit dem WLAN verbinden.",
      step_macos_4_title: "Prüfen ob andere Geräte betroffen sind",
      step_macos_4_desc:
        "Versuche mit einem anderen Gerät (z.B. Smartphone) eine Verbindung herzustellen. Wenn das andere Gerät auch kein Internet hat, liegt das Problem am Netzwerk – bitte melde es uns.",
      // ChromeOS steps
      step_chromeos_1_title: "WLAN aus- und wieder einschalten",
      step_chromeos_1_desc:
        "Klicke unten rechts auf die Systemzeit, dann auf das WLAN-Symbol um WLAN auszuschalten. Warte 10 Sekunden und schalte es wieder ein.",
      step_chromeos_2_title: "Netzwerk vergessen und neu verbinden",
      step_chromeos_2_desc:
        "Klicke unten rechts auf die Systemzeit und dann auf den Pfeil neben deinem Netzwerk. Wähle 'Vergessen' und verbinde dich anschließend neu.",
      step_chromeos_3_title: "Chromebook neu starten",
      step_chromeos_3_desc:
        "Klicke unten rechts auf die Systemzeit und dann auf das Ein-/Aus-Symbol. Wähle 'Neustart'. Nach dem Neustart erneut mit dem WLAN verbinden.",
      step_chromeos_4_title: "Prüfen ob andere Geräte betroffen sind",
      step_chromeos_4_desc:
        "Versuche mit einem anderen Gerät eine Verbindung herzustellen. Wenn das auch kein Internet hat, liegt das Problem am Netzwerk – bitte melde es uns.",
      // Linux steps
      step_linux_1_title: "WLAN aus- und wieder einschalten",
      step_linux_1_desc:
        "Klicke auf das Netzwerk-Symbol in der Menüleiste (oben rechts) und wähle 'WLAN ausschalten'. Warte 10 Sekunden und schalte es wieder ein.",
      step_linux_2_title: "Netzwerk vergessen und neu verbinden",
      step_linux_2_desc:
        "Klicke auf das Netzwerk-Symbol, dann auf dein Netzwerk und wähle 'Netzwerk vergessen'. Verbinde dich danach erneut und gib das Passwort ein.",
      step_linux_3_title: "Netzwerkdienst neu starten",
      step_linux_3_desc:
        "Öffne ein Terminal (Strg+Alt+T) und gib folgenden Befehl ein: sudo systemctl restart NetworkManager – dann Enter drücken und das Passwort eingeben.",
      step_linux_4_title: "Prüfen ob andere Geräte betroffen sind",
      step_linux_4_desc:
        "Versuche mit einem anderen Gerät eine Verbindung herzustellen. Wenn das auch kein Internet hat, liegt das Problem am Netzwerk – bitte melde es uns.",
      // Speedtest
      speedtest_title: "Verbindungstest",
      speedtest_intro: "Bitte starte kurz den Verbindungstest – so können wir dein Gerät automatisch erkennen und den Support deutlich beschleunigen.",
      speedtest_start_btn: "Test starten",
      speedtest_running: "Test läuft…",
      speedtest_done_btn: "Test abgeschlossen",
      speedtest_result_title: "Ergebnis",
      speedtest_download: "Download",
      speedtest_upload: "Upload",
      speedtest_ping: "Ping",
      speedtest_matched: "Dein Gerät wurde erkannt ✓",
      speedtest_no_match: "Gerät konnte nicht zugeordnet werden",
      speedtest_continue: "Weiter zur Problemhilfe",
      speedtest_skip: "Test überspringen",
      speedtest_error: "Der Test konnte nicht durchgeführt werden.",
      speedtest_retry_btn: "Erneut versuchen",
      speedtest_jitter: "Jitter",
      speedtest_phase_download: "Download",
      speedtest_phase_upload: "Upload",
      speedtest_phase_ping: "Ping",
      // Fallback form (PORTAL-3b)
      fallback_title: "Problem melden",
      fallback_intro: "Da wir dein Gerät nicht automatisch erkennen konnten, benötigen wir ein paar Angaben.",
      fallback_device_type: "Gerätetyp",
      fallback_device_phone: "Smartphone",
      fallback_device_laptop: "Laptop / PC",
      fallback_device_tablet: "Tablet",
      fallback_device_tv: "Smart-TV / Streaming-Gerät",
      fallback_device_other: "Sonstiges",
      fallback_apartment: "Wohnungs-Nr. / Bezeichnung",
      fallback_apartment_placeholder: "z.B. 3.OG links, Apt. 12",
      fallback_since: "Seit wann besteht das Problem?",
      fallback_since_today: "Heute",
      fallback_since_yesterday: "Gestern",
      fallback_since_week: "Seit mehreren Tagen",
      fallback_since_longer: "Länger als eine Woche",
      fallback_email: "E-Mail-Adresse",
      fallback_email_placeholder: "deine@email.de",
      fallback_privacy: "Ich habe die Datenschutzhinweise gelesen und stimme der Verarbeitung meiner Angaben zu.",
      fallback_privacy_pre: "Ich habe die",
      fallback_privacy_link: "Datenschutzhinweise",
      fallback_privacy_post: " gelesen und stimme der Verarbeitung meiner Angaben zu.",
      fallback_submit: "Problem melden",
      fallback_required_hint: "Bitte fülle alle Pflichtfelder aus (Gerätetyp und E-Mail).",
      fallback_required_field: "Dieses Feld ist erforderlich.",
      fallback_identification_auto: "Automatisch erkannt",
      fallback_identification_fallback: "Manuell angegeben (nicht verifiziert)",
      // Questionnaire (PORTAL-4)
      questionnaire_title: "Problem beschreiben",
      questionnaire_intro: "Beschreibe dein Problem so genau wie möglich.",
      questionnaire_description: "Fehlerbeschreibung",
      questionnaire_description_placeholder: "Was passiert genau? Seit wann? Welche Geräte sind betroffen?",
      questionnaire_chars_remaining: "{{count}} Zeichen verbleibend",
      questionnaire_screenshot: "Screenshot (optional)",
      questionnaire_screenshot_hint: "JPG oder PNG, max. 10 MB",
      questionnaire_screenshot_selected: "Datei ausgewählt: {{name}}",
      questionnaire_screenshot_error_type: "Nur JPG und PNG sind erlaubt.",
      questionnaire_screenshot_error_size: "Die Datei ist zu groß (max. 10 MB).",
      questionnaire_submit: "Absenden",
      questionnaire_required_hint: "Bitte fülle die Fehlerbeschreibung aus (mind. 10 Zeichen).",
      // Case ready (PORTAL-5)
      case_ready_title: "Vielen Dank!",
      case_ready_desc: "Deine Meldung wird bearbeitet.",
      case_ready_ticket_placeholder: "Ticketnummer wird in PORTAL-5 vergeben.",
      case_submitting: "Meldung wird eingereicht…",
      case_ticket_label: "Deine Ticketnummer",
      case_status_label: "Status",
      case_status_open: "Offen",
      case_status_in_progress: "In Bearbeitung",
      case_status_resolved: "Gelöst",
      case_last_updated: "Zuletzt aktualisiert",
      case_email_hint: "Wir informieren dich per E-Mail über Updates.",
      case_status_page_title: "Fallstatus",
      case_error: "Beim Einreichen ist ein Fehler aufgetreten.",
      // WifiCheckPage
      wifi_check_title: "Bist du mit dem WLAN verbunden?",
      wifi_check_yes: "Ja, ich bin verbunden",
      wifi_check_no: "Nein / ich weiß es nicht",
      // NoWifiHelpPage
      no_wifi_title: "Kein WLAN – so verbindest du dich",
      no_wifi_how_btn: "Wie verbinde ich mich mit dem WLAN?",
      no_wifi_available: "Verfügbare Netzwerke auf dieser Site:",
      no_wifi_available_fallback: "dem WLAN deiner Unterkunft",
      no_wifi_loading: "Netzwerke werden geladen…",
      no_wifi_connected: "Jetzt verbunden – weiter zum Test",
      no_wifi_report: "Problem besteht weiter – Fall melden",
      // Connect guides
      connect_ios_intro: "Öffne die Einstellungen-App und tippe auf 'WLAN'. Aktiviere WLAN falls nötig.",
      connect_ios_step1: "Einstellungen öffnen",
      connect_ios_step2: "Auf 'WLAN' tippen",
      connect_ios_step3: "Netzwerk aus der Liste wählen",
      connect_ios_step4: "Passwort eingeben und verbinden",
      connect_android_intro: "Öffne die Einstellungen und tippe auf 'WLAN' oder 'Verbindungen'.",
      connect_android_step1: "Einstellungen öffnen",
      connect_android_step2: "Auf 'WLAN' tippen",
      connect_android_step3: "Netzwerk aus der Liste wählen",
      connect_android_step4: "Passwort eingeben und verbinden",
      connect_windows_intro: "Klicke unten rechts auf das WLAN-Symbol in der Taskleiste.",
      connect_windows_step1: "WLAN-Symbol in der Taskleiste anklicken",
      connect_windows_step2: "Netzwerk aus der Liste auswählen",
      connect_windows_step3: "Auf 'Verbinden' klicken",
      connect_windows_step4: "Passwort eingeben und bestätigen",
      connect_macos_intro: "Klicke oben rechts auf das WLAN-Symbol in der Menüleiste.",
      connect_macos_step1: "WLAN-Symbol in der Menüleiste anklicken",
      connect_macos_step2: "Netzwerk aus der Liste wählen",
      connect_macos_step3: "Passwort eingeben",
      connect_macos_step4: "Auf 'Verbinden' klicken",
      // IpConfirmPage
      ip_confirm_matched_title: "Gerät erkannt",
      ip_confirm_matched_desc: "Wir haben ein Gerät mit dieser IP-Adresse in deinem Netzwerk gefunden:",
      ip_confirm_question: "Ist das deine IP-Adresse?",
      ip_confirm_yes: "Ja, das bin ich",
      ip_confirm_skip: "Überspringen",
      ip_confirm_no_match_title: "Gerät nicht erkannt",
      ip_confirm_no_match_desc: "Gib deine WLAN-IP-Adresse ein:",
      ip_confirm_ip_placeholder: "z.B. 192.168.1.42",
      ip_confirm_check_btn: "Prüfen",
      ip_confirm_how_btn: "Wo finde ich meine IP-Adresse?",
      ip_confirm_not_found: "Diese IP wurde im Netzwerk nicht gefunden.",
      ip_confirm_checking: "Wird geprüft…",
      ip_guide_close: "Schließen",
      // Ticket view (CASE-1 Phase 4)
      ticket_number: "Ticketnummer",
      ticket_status: "Status",
      ticket_priority: "Priorität",
      ticket_diagnosis: "Diagnose",
      ticket_timeline: "Verlauf",
      ticket_comment_placeholder: "Deine Nachricht…",
      ticket_comment_send: "Senden",
      ticket_first_name: "Vorname",
      ticket_last_name: "Nachname",
      ticket_solved_btn: "Problem gelöst melden",
      ticket_solved_comment_placeholder: "Beschreibe kurz, was geholfen hat (min. 10 Zeichen)…",
      ticket_solved_confirm: "Bestätigen",
      ticket_solved_cancel: "Abbrechen",
      ticket_solved_success: "Danke für deine Rückmeldung!",
      ticket_comment_sent: "Kommentar gesendet.",
      ticket_name_required: "Bitte gib deinen Namen an.",
      ticket_status_open: "Offen",
      ticket_status_in_progress: "In Bearbeitung",
      ticket_status_resolved: "Gelöst",
      ticket_priority_low: "Niedrig",
      ticket_priority_medium: "Mittel",
      ticket_priority_high: "Hoch",
      ticket_priority_critical: "Kritisch",
      // Token expired (CASE-1 Phase 4)
      token_expired_title: "Link abgelaufen",
      token_expired_text: "Dein Zugangslink ist abgelaufen oder ungültig.",
      token_expired_email_label: "Deine E-Mail-Adresse",
      token_expired_submit: "Neuen Link anfordern",
      // Link requested (CASE-1 Phase 4)
      link_requested_title: "Link angefordert",
      link_requested_text: "Falls ein offener Fall mit dieser E-Mail-Adresse existiert, haben wir dir einen neuen Zugangslink gesendet. Prüfe auch deinen Spam-Ordner.",
      // WL-1c: FAQ section
      faq_title: "Häufige Fragen",
      // AUDIT-SEC-2/S3: DSGVO footer links
      footer_privacy: "Datenschutz",
      footer_impressum: "Impressum",
    },
  },
  en: {
    translation: {
      status_ok: "Everything's Fine",
      status_ok_desc: "No known issues at this site.",
      status_disruption: "Disruption Detected",
      status_disruption_desc: "There is a known disruption – we are working on it.",
      disruption_report_anyway: "Report anyway",
      status_help_title: "Wi-Fi Problems?",
      status_help_desc: "We'll guide you through step-by-step – or you can submit a ticket directly.",
      since: "Since",
      error_title: "Page Not Found",
      error_desc: "This link is invalid or has expired.",
      loading: "Loading…",
      severity_critical: "Critical",
      severity_warning: "Warning",
      check_wan_down: "Internet connection down",
      check_ap_offline: "Access point unreachable",
      check_controller_offline: "Controller unreachable",
      check_dhcp_pool_exhaustion: "Network congested",
      check_disconnect_spike: "Increased disconnects",
      check_unknown: "Unknown issue",
      // Self-help general
      selfhelp_title: "Self-Help",
      selfhelp_intro: "Please follow these steps to resolve the issue.",
      os_select_label: "Select your OS",
      os_ios: "iPhone / iPad",
      os_android: "Android",
      os_windows: "Windows",
      os_macos: "macOS",
      os_chromeos: "ChromeOS",
      os_linux: "Linux",
      step_x_of_y: "Step {{current}} of {{total}}",
      step_next: "Next",
      step_prev: "Back",
      step_problem_solved: "Problem solved ✓",
      step_still_problem: "Still having issues?",
      report_problem: "Report issue",
      disruption_help_anyway: "Need help anyway?",
      start_help: "Start Wi-Fi Help",
      selfhelp_solved_title: "Great job!",
      selfhelp_solved_desc: "Glad the problem is resolved.",
      back_to_status: "Back to status page",
      os_detected: "Detected OS",
      os_change: "Change OS",
      // iOS steps
      step_ios_1_title: "Turn Wi-Fi off and back on",
      step_ios_1_desc:
        "Open the Settings app and tap 'Wi-Fi'. Turn Wi-Fi off, wait 5 seconds, and turn it back on.",
      step_ios_2_title: "Forget the network and reconnect",
      step_ios_2_desc:
        "In Wi-Fi settings, tap the (i) next to the network name. Select 'Forget This Network', then reconnect.",
      step_ios_3_title: "Toggle Airplane Mode briefly",
      step_ios_3_desc:
        "Swipe down from the top of the screen to open Control Center. Tap the airplane icon, wait 10 seconds, then tap it again to turn it off.",
      step_ios_4_title: "Restart your iPhone",
      step_ios_4_desc:
        "Hold the side button and a volume button until the power slider appears. Slide to turn off, wait 30 seconds, then turn it back on.",
      // Android steps
      step_android_1_title: "Turn Wi-Fi off and back on",
      step_android_1_desc:
        "Swipe down from the top of the screen to open Quick Settings. Tap the Wi-Fi icon to turn it off, wait 5 seconds, then tap it again.",
      step_android_2_title: "Forget the network and reconnect",
      step_android_2_desc:
        "Open Settings and tap 'Wi-Fi'. Long-press the network name and select 'Forget'. Then reconnect.",
      step_android_3_title: "Restart your device",
      step_android_3_desc:
        "Hold the power button and select 'Restart'. Reconnect to Wi-Fi after the restart.",
      step_android_4_title: "Toggle Airplane Mode briefly",
      step_android_4_desc:
        "Swipe down from the top of the screen and tap the airplane icon. Wait 10 seconds, then turn Airplane Mode off again.",
      // Windows steps
      step_windows_1_title: "Turn Wi-Fi off and back on",
      step_windows_1_desc:
        "Click the Wi-Fi icon in the bottom-right taskbar and click 'Wi-Fi off'. Wait 10 seconds and turn it back on.",
      step_windows_2_title: "Disconnect and reconnect",
      step_windows_2_desc:
        "Click the Wi-Fi icon in the taskbar, then click your network and select 'Disconnect'. Then click the network again to reconnect.",
      step_windows_3_title: "Restart your computer",
      step_windows_3_desc:
        "Click the Windows icon, then the power button, and select 'Restart'. Reconnect to Wi-Fi after the restart.",
      step_windows_4_title: "Check if other devices are affected",
      step_windows_4_desc:
        "Try connecting with another device (e.g. your phone). If that device also has no internet, the problem is with the network — please report it to us.",
      // macOS steps
      step_macos_1_title: "Turn Wi-Fi off and back on",
      step_macos_1_desc:
        "Click the Wi-Fi icon in the top-right menu bar and select 'Turn Wi-Fi Off'. Wait 5 seconds and turn it back on.",
      step_macos_2_title: "Forget the network and reconnect",
      step_macos_2_desc:
        "Open System Settings and click 'Wi-Fi'. Click 'Details' next to the network name, then 'Forget This Network'. Reconnect afterwards.",
      step_macos_3_title: "Restart your Mac",
      step_macos_3_desc:
        "Click the Apple icon in the top-left corner and select 'Restart…'. Reconnect to Wi-Fi after the restart.",
      step_macos_4_title: "Check if other devices are affected",
      step_macos_4_desc:
        "Try connecting with another device (e.g. your phone). If that device also has no internet, the problem is with the network — please report it to us.",
      // ChromeOS steps
      step_chromeos_1_title: "Turn Wi-Fi off and back on",
      step_chromeos_1_desc:
        "Click the system clock in the bottom-right corner, then click the Wi-Fi icon to turn it off. Wait 10 seconds and turn it back on.",
      step_chromeos_2_title: "Forget the network and reconnect",
      step_chromeos_2_desc:
        "Click the system clock, then click the arrow next to your network. Select 'Forget' and reconnect afterwards.",
      step_chromeos_3_title: "Restart your Chromebook",
      step_chromeos_3_desc:
        "Click the system clock, then the power icon, and select 'Restart'. Reconnect to Wi-Fi after the restart.",
      step_chromeos_4_title: "Check if other devices are affected",
      step_chromeos_4_desc:
        "Try connecting with another device. If that device also has no internet, the problem is with the network — please report it to us.",
      // Linux steps
      step_linux_1_title: "Turn Wi-Fi off and back on",
      step_linux_1_desc:
        "Click the network icon in the menu bar (top-right) and select 'Turn Off Wi-Fi'. Wait 10 seconds and turn it back on.",
      step_linux_2_title: "Forget the network and reconnect",
      step_linux_2_desc:
        "Click the network icon, then your network name and select 'Forget Network'. Reconnect afterwards and enter the password.",
      step_linux_3_title: "Restart the network service",
      step_linux_3_desc:
        "Open a terminal (Ctrl+Alt+T) and enter: sudo systemctl restart NetworkManager — then press Enter and type your password.",
      step_linux_4_title: "Check if other devices are affected",
      step_linux_4_desc:
        "Try connecting with another device. If that device also has no internet, the problem is with the network — please report it to us.",
      // Speedtest
      speedtest_title: "Connection Test",
      speedtest_intro: "Please run a quick connection test – this allows us to automatically identify your device and speed up support significantly.",
      speedtest_start_btn: "Start Test",
      speedtest_running: "Test running…",
      speedtest_done_btn: "Test completed",
      speedtest_result_title: "Result",
      speedtest_download: "Download",
      speedtest_upload: "Upload",
      speedtest_ping: "Ping",
      speedtest_matched: "Your device was identified ✓",
      speedtest_no_match: "Device could not be identified",
      speedtest_continue: "Continue to help",
      speedtest_skip: "Skip test",
      speedtest_error: "The test could not be completed.",
      speedtest_retry_btn: "Try again",
      speedtest_jitter: "Jitter",
      speedtest_phase_download: "Download",
      speedtest_phase_upload: "Upload",
      speedtest_phase_ping: "Ping",
      // Fallback form (PORTAL-3b)
      fallback_title: "Report Issue",
      fallback_intro: "Since we couldn't identify your device automatically, we need a few details.",
      fallback_device_type: "Device type",
      fallback_device_phone: "Smartphone",
      fallback_device_laptop: "Laptop / PC",
      fallback_device_tablet: "Tablet",
      fallback_device_tv: "Smart TV / Streaming device",
      fallback_device_other: "Other",
      fallback_apartment: "Apartment number / name",
      fallback_apartment_placeholder: "e.g. 3rd floor left, Apt. 12",
      fallback_since: "Since when does the problem exist?",
      fallback_since_today: "Today",
      fallback_since_yesterday: "Yesterday",
      fallback_since_week: "Several days",
      fallback_since_longer: "More than a week",
      fallback_email: "Email address",
      fallback_email_placeholder: "your@email.com",
      fallback_privacy: "I have read the privacy notice and agree to the processing of my data.",
      fallback_privacy_pre: "I have read the",
      fallback_privacy_link: "privacy notice",
      fallback_privacy_post: " and agree to the processing of my data.",
      fallback_submit: "Submit report",
      fallback_required_hint: "Please fill in all required fields (device type and email).",
      fallback_required_field: "This field is required.",
      fallback_identification_auto: "Auto-identified",
      fallback_identification_fallback: "Manually entered (not verified)",
      // Questionnaire (PORTAL-4)
      questionnaire_title: "Describe Your Problem",
      questionnaire_intro: "Please describe your problem in as much detail as possible.",
      questionnaire_description: "Problem description",
      questionnaire_description_placeholder: "What exactly happens? Since when? Which devices are affected?",
      questionnaire_chars_remaining: "{{count}} characters remaining",
      questionnaire_screenshot: "Screenshot (optional)",
      questionnaire_screenshot_hint: "JPG or PNG, max. 10 MB",
      questionnaire_screenshot_selected: "File selected: {{name}}",
      questionnaire_screenshot_error_type: "Only JPG and PNG files are allowed.",
      questionnaire_screenshot_error_size: "The file is too large (max. 10 MB).",
      questionnaire_submit: "Submit",
      questionnaire_required_hint: "Please fill in the problem description (min. 10 characters).",
      // Case ready (PORTAL-5)
      case_ready_title: "Thank you!",
      case_ready_desc: "Your report is being processed.",
      case_ready_ticket_placeholder: "Ticket number will be assigned in PORTAL-5.",
      case_submitting: "Submitting report…",
      case_ticket_label: "Your ticket number",
      case_status_label: "Status",
      case_status_open: "Open",
      case_status_in_progress: "In Progress",
      case_status_resolved: "Resolved",
      case_last_updated: "Last updated",
      case_email_hint: "We'll notify you by email about updates.",
      case_status_page_title: "Case Status",
      case_error: "An error occurred while submitting.",
      // WifiCheckPage
      wifi_check_title: "Are you connected to Wi-Fi?",
      wifi_check_yes: "Yes, I'm connected",
      wifi_check_no: "No / I'm not sure",
      // NoWifiHelpPage
      no_wifi_title: "No Wi-Fi – Here's How to Connect",
      no_wifi_how_btn: "How do I connect to Wi-Fi?",
      no_wifi_available: "Available networks at this site:",
      no_wifi_available_fallback: "the Wi-Fi of your accommodation",
      no_wifi_loading: "Loading networks…",
      no_wifi_connected: "Connected – continue to test",
      no_wifi_report: "Problem persists – report an issue",
      // Connect guides
      connect_ios_intro: "Open the Settings app and tap 'Wi-Fi'. Enable Wi-Fi if needed.",
      connect_ios_step1: "Open Settings",
      connect_ios_step2: "Tap 'Wi-Fi'",
      connect_ios_step3: "Select your network from the list",
      connect_ios_step4: "Enter the password and connect",
      connect_android_intro: "Open Settings and tap 'Wi-Fi' or 'Connections'.",
      connect_android_step1: "Open Settings",
      connect_android_step2: "Tap 'Wi-Fi'",
      connect_android_step3: "Select your network from the list",
      connect_android_step4: "Enter the password and connect",
      connect_windows_intro: "Click the Wi-Fi icon in the bottom-right taskbar.",
      connect_windows_step1: "Click the Wi-Fi icon in the taskbar",
      connect_windows_step2: "Select your network from the list",
      connect_windows_step3: "Click 'Connect'",
      connect_windows_step4: "Enter the password and confirm",
      connect_macos_intro: "Click the Wi-Fi icon in the top-right menu bar.",
      connect_macos_step1: "Click the Wi-Fi icon in the menu bar",
      connect_macos_step2: "Select your network from the list",
      connect_macos_step3: "Enter the password",
      connect_macos_step4: "Click 'Connect'",
      // IpConfirmPage
      ip_confirm_matched_title: "Device Identified",
      ip_confirm_matched_desc: "We found a device with this IP address on your network:",
      ip_confirm_question: "Is this your IP address?",
      ip_confirm_yes: "Yes, that's me",
      ip_confirm_skip: "Skip",
      ip_confirm_no_match_title: "Device Not Identified",
      ip_confirm_no_match_desc: "Enter your Wi-Fi IP address:",
      ip_confirm_ip_placeholder: "e.g. 192.168.1.42",
      ip_confirm_check_btn: "Check",
      ip_confirm_how_btn: "Where do I find my IP address?",
      ip_confirm_not_found: "This IP address was not found on the network.",
      ip_confirm_checking: "Checking…",
      ip_guide_close: "Close",
      // Ticket view (CASE-1 Phase 4)
      ticket_number: "Ticket Number",
      ticket_status: "Status",
      ticket_priority: "Priority",
      ticket_diagnosis: "Diagnosis",
      ticket_timeline: "Timeline",
      ticket_comment_placeholder: "Your message…",
      ticket_comment_send: "Send",
      ticket_first_name: "First Name",
      ticket_last_name: "Last Name",
      ticket_solved_btn: "Report Problem Solved",
      ticket_solved_comment_placeholder: "Briefly describe what helped (min. 10 characters)…",
      ticket_solved_confirm: "Confirm",
      ticket_solved_cancel: "Cancel",
      ticket_solved_success: "Thank you for your feedback!",
      ticket_comment_sent: "Comment sent.",
      ticket_name_required: "Please enter your name.",
      ticket_status_open: "Open",
      ticket_status_in_progress: "In Progress",
      ticket_status_resolved: "Resolved",
      ticket_priority_low: "Low",
      ticket_priority_medium: "Medium",
      ticket_priority_high: "High",
      ticket_priority_critical: "Critical",
      // Token expired (CASE-1 Phase 4)
      token_expired_title: "Link Expired",
      token_expired_text: "Your access link has expired or is invalid.",
      token_expired_email_label: "Your Email Address",
      token_expired_submit: "Request New Link",
      // Link requested (CASE-1 Phase 4)
      link_requested_title: "Link Requested",
      link_requested_text: "If an open case with this email address exists, we have sent you a new access link. Please also check your spam folder.",
      // WL-1c: FAQ section
      faq_title: "Frequently Asked Questions",
      // AUDIT-SEC-2/S3: DSGVO footer links
      footer_privacy: "Privacy Policy",
      footer_impressum: "Legal Notice",
    },
  },
};

const browserLang = navigator.language.startsWith("de") ? "de" : "en";

i18next.use(initReactI18next).init({
  resources,
  lng: browserLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18next;
